import api from "../../../api";

// Property Compliance (DOMA 12954696393). `propertyId` may be the CRM Property
// id or the Collings-page crawler id; the backend resolves both.
const base = (propertyId) => `/api/property-compliance/properties/${encodeURIComponent(propertyId)}/compliance/`;

export const getComplianceFile = (propertyId, { recompute = false } = {}) =>
  api.get(base(propertyId), { params: recompute ? { recompute: 1 } : {} });

export const recomputeCompliance = (propertyId) => api.post(base(propertyId));

export const getComplianceEvents = (propertyId, { offset = 0, limit = 100 } = {}) =>
  api.get(`${base(propertyId)}events/`, { params: { offset, limit } });

export const uploadComplianceDocument = (propertyId, { requirementKey, file, executedAt, status, note, extra = {} }) => {
  const formData = new FormData();
  formData.append("requirement_key", requirementKey);
  formData.append("file", file);
  if (executedAt) formData.append("executed_at", executedAt);
  if (status) formData.append("status", status);
  if (note) formData.append("note", note);
  Object.entries(extra).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") formData.append(k, v);
  });
  return api.post(`${base(propertyId)}documents/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const docAction = (documentId, action, body = {}) =>
  api.post(`/api/property-compliance/compliance-documents/${encodeURIComponent(documentId)}/${action}/`, body);

export const setComplianceDocumentCurrent = (documentId, note = "") => docAction(documentId, "set-current", { note });
export const reviewComplianceDocument = (documentId, note = "") => docAction(documentId, "review", { note });
export const voidComplianceDocument = (documentId, reason) => docAction(documentId, "void", { reason });

export const markRequirementNotApplicable = (propertyId, key, reason) =>
  api.post(`${base(propertyId)}items/${encodeURIComponent(key)}/na/`, { reason });
export const clearRequirementNotApplicable = (propertyId, key) =>
  api.post(`${base(propertyId)}items/${encodeURIComponent(key)}/clear-na/`);

export const getComplianceSettings = () => api.get("/api/property-compliance/settings/");
export const updateComplianceSettings = (data) => api.put("/api/property-compliance/settings/", data);

export const recordVendorNotified = (propertyId, priceEventId, { how, at, note } = {}) =>
  api.post(`${base(propertyId)}price-events/${encodeURIComponent(priceEventId)}/vendor-notified/`, { how, at, note });

export const getPricingEvidence = (propertyId) => api.get(`${base(propertyId)}pricing-evidence/`);
export const savePricingEvidence = (propertyId, data) => api.put(`${base(propertyId)}pricing-evidence/`, data);
export const prefillPricingEvidence = (propertyId) => api.get(`${base(propertyId)}pricing-evidence/prefill/`);

// kind: "pdf" (summary) or "zip" (summary + every evidence file). Returns a Blob response.
export const exportComplianceFile = (propertyId, kind = "pdf") =>
  api.get(`${base(propertyId)}export/`, { params: { kind }, responseType: "blob" });

export const setDeliveryPartyRole = (propertyId, deliveryId, partyRole) =>
  api.post(`${base(propertyId)}deliveries/${encodeURIComponent(deliveryId)}/role/`, { party_role: partyRole });
